import { APIRequestKey } from '../types';

export * from './accessControls';

export const API_REQUEST_KEYS: Record<string, APIRequestKey> = {
  // Config
  GET_SUPPORTED_COUNTRIES: 'config:getSupportedCountries',

  // Departments
  DEPARTMENTS_GET_ALL: 'departments:getAll',
  DEPARTMENTS_GET_BY_OUTLET: 'departments:getByOutlet',
  DEPARTMENTS_CREATE: 'departments:create',
  DEPARTMENTS_UPDATE: 'departments:update',
  DEPARTMENTS_DELETE: 'departments:delete',

  // Menu Categories
  CATEGORIES_GET_BY_OUTLET: 'categories:getByOutlet',
  CATEGORIES_CREATE: 'categories:create',
  CATEGORIES_UPDATE: 'categories:update',
  CATEGORIES_DELETE: 'categories:delete',

  // Menu Items
  MENU_ITEMS_GET_BY_OUTLET: 'menuItems:getByOutlet',
  MENU_ITEMS_GET_BY_CATEGORY: 'menuItems:getByCategory',
  MENU_ITEMS_CREATE: 'menuItems:create',
  MENU_ITEMS_UPDATE: 'menuItems:update',
  MENU_ITEMS_DELETE: 'menuItems:delete',

  // Addons
  ADDONS_GET_BY_OUTLET: 'addons:getByOutlet',
  ADDONS_CREATE: 'addons:create',
  ADDONS_UPDATE: 'addons:update',
  ADDONS_DELETE: 'addons:delete',

  // Item Addons
  ITEM_ADDONS_GET_BY_ITEM: 'itemAddons:getByItem',
  ITEM_ADDONS_ADD: 'itemAddons:add',
  ITEM_ADDONS_UPDATE: 'itemAddons:update',
  ITEM_ADDONS_REMOVE: 'itemAddons:remove',

  // Auth
  AUTH_REGISTER_USER: 'auth:register',
  AUTH_VERIFY_EMAIL: 'auth:verifyEmail',
  AUTH_SETUP_ACCOUNT: 'auth:setupAccount',
  AUTH_LOGIN: 'auth:login',
  AUTH_LOGOUT: 'auth:logout',
  AUTH_GET_CURRENT_USER: 'auth:getCurrentUser',
  AUTH_GOOGLE_SIGN_IN: 'auth:googleSignIn',
};
